import React from 'react';
import { ISectionStyles, useSectionStyles } from '../';



export interface SectionTitleProps extends React.FormHTMLAttributes<HTMLFormElement> {
}

export const SectionTitle: React.FC<SectionTitleProps> = (props) => {  
    const styles: ISectionStyles = useSectionStyles();
    

    if ((props.children === null || props.children === undefined)) {
        return null;
    }

    return (
        <span {...props} style={{ ...styles.headerTitle, ...props.style }} />
    );
};